import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "logo position-absolute start-0 end-0 top-0 transition" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "border-bottom" }, null, -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "ph-duotone ph-caret-double-right" }, null, -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "sidebar-menu transition" }
const _hoisted_7 = {
  class: "sidebar-navbar-nav ps-0 mb-0 list-unstyled accordion",
  id: "sidebarNavAccordion"
}
const _hoisted_8 = { class: "sidebar-nav-item" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-house" }, null, -1 /* HOISTED */)
const _hoisted_10 = { class: "title" }
const _hoisted_11 = {
  key: 0,
  class: "sidebar-nav-item"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-user" }, null, -1 /* HOISTED */)
const _hoisted_13 = { class: "title" }
const _hoisted_14 = {
  key: 0,
  class: "sidebar-nav-item"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-users-four" }, null, -1 /* HOISTED */)
const _hoisted_16 = { class: "title" }
const _hoisted_17 = {
  key: 1,
  class: "sidebar-nav-item"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-user-plus" }, null, -1 /* HOISTED */)
const _hoisted_19 = { class: "title" }
const _hoisted_20 = {
  key: 2,
  class: "sidebar-nav-item"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-users" }, null, -1 /* HOISTED */)
const _hoisted_22 = { class: "title" }
const _hoisted_23 = {
  key: 3,
  class: "sidebar-nav-item"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-buildings" }, null, -1 /* HOISTED */)
const _hoisted_25 = { class: "title" }
const _hoisted_26 = {
  key: 4,
  class: "sidebar-nav-item"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-user-circle-gear" }, null, -1 /* HOISTED */)
const _hoisted_28 = { class: "title" }
const _hoisted_29 = {
  key: 5,
  class: "sidebar-nav-item"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-question" }, null, -1 /* HOISTED */)
const _hoisted_31 = { class: "title" }
const _hoisted_32 = {
  key: 6,
  class: "sidebar-nav-item"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-list-checks" }, null, -1 /* HOISTED */)
const _hoisted_34 = { class: "title" }
const _hoisted_35 = {
  key: 7,
  class: "sidebar-nav-item"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-globe-simple" }, null, -1 /* HOISTED */)
const _hoisted_37 = { class: "title" }
const _hoisted_38 = {
  key: 2,
  class: "sidebar-nav-item"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-book-open-text" }, null, -1 /* HOISTED */)
const _hoisted_40 = { class: "title" }
const _hoisted_41 = { class: "sidebar-nav-item" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-sign-out" }, null, -1 /* HOISTED */)
const _hoisted_43 = { class: "title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
    'sidebar-area position-fixed start-0 top-0 bg-black h-100vh transition',
    { active: _ctx.sidebarStoreInstance.open },
  ]),
    id: "sidebar-area"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "d-flex align-items-center text-white text-decoration-none"
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: _ctx.getEnvAsset('/images/logo.svg'),
            alt: "logo-icon",
            class: "img-fluid h-20"
          }, null, 8 /* PROPS */, _hoisted_2)
        ]),
        _: 1 /* STABLE */
      }),
      _hoisted_3,
      _createElementVNode("button", {
        class: "sidebar-burger-menu position-absolute lh-1 bg-transparent p-0 border-0",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.sidebarStoreInstance.onChange && _ctx.sidebarStoreInstance.onChange(...args)))
      }, [..._hoisted_5])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("ul", _hoisted_7, [
        _createCommentVNode(" PATIENTS "),
        _createElementVNode("li", _hoisted_8, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "sidebar-nav-link d-block"
          }, {
            default: _withCtx(() => [
              _hoisted_9,
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('page.home')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _createCommentVNode(" PATIENTS "),
        (_ctx.indexEnabled)
          ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
              _createVNode(_component_router_link, {
                to: "/patients",
                class: "sidebar-nav-link d-block"
              }, {
                default: _withCtx(() => [
                  _hoisted_12,
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('page.patients')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              })
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" MESSAGES "),
        _createCommentVNode(" <li class=\"sidebar-nav-item\" v-if=\"config.feature.messages && indexEnabled\">\n          <router-link to=\"/messages\" class=\"sidebar-nav-link d-block\">\n            <i class=\"ph ph-chat-circle\"></i>\n            <span class=\"title\">{{ $t('page.messages') }}</span>\n          </router-link>\n        </li> "),
        (_ctx.isAdmin || _ctx.isInternal)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createCommentVNode(" SYSTEM USERS "),
              (_ctx.isAdmin)
                ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                    _createVNode(_component_router_link, {
                      to: "/system-users",
                      class: "sidebar-nav-link d-block"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_15,
                        _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('page.system_users')), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" INVITATIONS "),
              (_ctx.isInternal && _ctx.assignment_strategy === 'by_hcp')
                ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                    _createVNode(_component_router_link, {
                      to: "/invite-user",
                      class: "sidebar-nav-link d-block"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_18,
                        _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('page.invite_user')), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" HCP LIST "),
              (_ctx.isInternal && _ctx.assignment_strategy === 'by_hcp')
                ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
                    _createVNode(_component_router_link, {
                      to: "/zone-hcp-list",
                      class: "sidebar-nav-link d-block"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_21,
                        _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('page.users')), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" CENTERS "),
              (_ctx.isAdmin || _ctx.assignment_strategy === 'by_center')
                ? (_openBlock(), _createElementBlock("li", _hoisted_23, [
                    _createVNode(_component_router_link, {
                      to: "/system-centers",
                      class: "sidebar-nav-link d-block"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_24,
                        _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('page.centers')), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" ROLES "),
              (_ctx.isAdmin)
                ? (_openBlock(), _createElementBlock("li", _hoisted_26, [
                    _createVNode(_component_router_link, {
                      to: "/system-roles",
                      class: "sidebar-nav-link d-block"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_27,
                        _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t('page.roles')), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" SURVEYS "),
              (_ctx.isAdmin && _ctx.config.feature.surveys)
                ? (_openBlock(), _createElementBlock("li", _hoisted_29, [
                    _createVNode(_component_router_link, {
                      to: "/surveys",
                      class: "sidebar-nav-link d-block"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_30,
                        _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('page.surveys')), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" CONSENTS "),
              ((_ctx.isAdmin || _ctx.isInternal) && _ctx.config.feature.consents)
                ? (_openBlock(), _createElementBlock("li", _hoisted_32, [
                    _createVNode(_component_router_link, {
                      to: "/consents",
                      class: "sidebar-nav-link d-block"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_33,
                        _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.$t('page.consents')), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" CONSENTS "),
              (_ctx.isAdmin)
                ? (_openBlock(), _createElementBlock("li", _hoisted_35, [
                    _createVNode(_component_router_link, {
                      to: "/zones",
                      class: "sidebar-nav-link d-block"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_36,
                        _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$t('page.zones')), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]))
                : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" CONTENT LIBRARY "),
        (_ctx.isContentManager)
          ? (_openBlock(), _createElementBlock("li", _hoisted_38, [
              _createVNode(_component_router_link, {
                to: "/contents",
                class: "sidebar-nav-link d-block"
              }, {
                default: _withCtx(() => [
                  _hoisted_39,
                  _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.$t('page.contents')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              })
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" LOGOUT "),
        _createElementVNode("li", _hoisted_41, [
          _createVNode(_component_router_link, {
            to: "/logout",
            class: "sidebar-nav-link d-block"
          }, {
            default: _withCtx(() => [
              _hoisted_42,
              _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.$t('cta.logout')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          })
        ])
      ])
    ])
  ], 2 /* CLASS */))
}